module.exports = __webpack_public_path__ + "static/twig_blight-2-5c3167ba0a95a6e846a29bd6aad07522.jpg";